import { useState } from "react";
import { useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  createFinanceItem,
  deleteFinanceItem,
  updateAssets,
} from "../store/slices/applicationFormSlice";
import InputAdornment from "@mui/material/InputAdornment";
import { camelCase } from "lodash";
import { IconButton, Stack } from "@mui/material";

export default function CustomerAssets({ assets, index, isAssetLiabilitiesRequired, id }) {
  const dispatch = useDispatch();
  const [assetsValues, setAssetsValues] = useState(assets?.items || []);
  const [newAssetName, setNewAssetName] = useState("");
  const [isHovering, setIsHovering] = useState({});

  const handleAssets = (update) => {
    dispatch(updateAssets(update));
  };

  async function handleCreateAsset() {
    await dispatch(
      createFinanceItem({
        data: {
          name: camelCase(newAssetName),
          label: newAssetName,
          assetsId: assets?._id,
        },
        endpoint: "customer-assets",
      })
    ).unwrap();
    setNewAssetName("");
  }

  async function handleDeleteAsset(data) {
    await dispatch(
      deleteFinanceItem({
        data,
        endpoint: "customer-assets",
      })
    ).unwrap();
  }

  return (
    <Grid
      container
      item
      xs={12}
      sm={6}
      spacing={0}
      direction="column"
      style={{ alignContent: "flex-start" }}
    >
      <Typography variant="subtitle2" style={{ marginBottom: "20px" }} id={id}>
        Assets
      </Typography>

      <Stack spacing={1}>
        {assets?.items?.map((asset, i) => {
          const assetId = asset._id;
          return (
            <TextField
              id="outlined-basic"
              type="text"
              size="small"
              name={asset.name}
              label={asset.label}
              variant="outlined"
              error={
                i === 0 && index === 0 && isAssetLiabilitiesRequired
                  ? !asset.value
                  : false
              }
              helperText={
                i === 0 && index === 0 && isAssetLiabilitiesRequired && !asset.value
                  ? "Required"
                  : ""
              }
              value={
                assetsValues.filter((value) => value?._id === asset?._id)?.[0]
                  ?.value
              }
              onMouseEnter={() => {
                setIsHovering({ ...isHovering, [assetId]: true });
              }}
              onMouseLeave={() => {
                setIsHovering({ ...isHovering, [assetId]: false });
              }}
              onChange={(event) => {
                const currentAsset = assetsValues.filter(
                  (value) => value._id === assetId
                );
                const newAssetValues = assetsValues.filter(
                  (value) => value._id !== assetId
                );
                currentAsset.value = event.target.value;
                setAssetsValues([...newAssetValues, ...currentAsset]);
              }}
              onBlur={(event) =>
                handleAssets({
                  assetId: assetId,
                  value: event.target.value,
                  assetsId: assets._id,
                })
              }
              inputProps={{
                autoComplete: "none",
              }}
              InputProps={{
                startAdornment: assetsValues[asset.name] ? (
                  <InputAdornment position="start">$</InputAdornment>
                ) : null,
                endAdornment: isHovering[assetId] && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        handleDeleteAsset({
                          assetId: assetId,
                          assetsId: assets._id,
                        })
                      }
                      edge="end"
                    >
                      <DeleteForeverIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )
        })}

        <TextField
          id="outlined-basic"
          type="text"
          size="small"
          label="Add asset"
          variant="outlined"
          onChange={(event) => setNewAssetName(event.target.value)}
          value={newAssetName}
          placeholder="Asset name"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={(event) => {
                    if (newAssetName) {
                      handleCreateAsset(event);
                    }
                  }}
                  style={{
                    background: newAssetName ? "#9c27b0" : "none",
                    color: newAssetName ? "#fff" : "rgba(0, 0, 0, 0.6)",
                    height: "30px",
                  }}
                  edge="end"
                >
                  +
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
    </Grid>
  );
}
